export type TGeneralValuesObject = {
  [key: string]: any;
  age: [number, number];
  cadence: object;
  stride_length: object;
  speed: object;
};

export type TGeneralValues = {
  [key: number]: TGeneralValuesObject[];
  men: TGeneralValuesObject[];
  women: TGeneralValuesObject[];
};

export enum EColorState {
  'badRange',
  'warningRange',
  'goodRange',
}

export default class RefInt {
  private static VALUES_GENERAL: TGeneralValues = {
    women: [
      {
        age: [0, 14],
        cadence: {
          base: [114.75, 138.25],
          min: [103, 114.75],
          max: [138.25, 150],
          extremMax: 161.75,
          extremMin: 91.25,
        },
        stride_length: {
          base: [113, 141],
          min: [99, 113],
          max: [141, 155],
          extremMax: 169,
          extremMin: 85,
        },
        speed: {
          base: [3.89, 5.18],
          min: [3.24, 3.89],
          max: [5.18, 5.83],
          extremMax: 6.48,
          extremMin: 2.59,
        },
      },
      {
        age: [15, 17],
        cadence: {
          base: [111, 133],
          min: [100, 111],
          max: [133, 144],
          extremMax: 155,
          extremMin: 89,
        },
        stride_length: {
          base: [116.5, 143.5],
          min: [103, 116.5],
          max: [143.5, 157],
          extremMax: 170.5,
          extremMin: 89.5,
        },
        speed: {
          base: [3.96, 5.26],
          min: [3.31, 3.96],
          max: [5.26, 5.9],
          extremMax: 6.55,
          extremMin: 2.66,
        },
      },
      {
        age: [18, 49],
        cadence: {
          base: [108, 128],
          min: [98, 108],
          max: [128, 138],
          extremMax: 148,
          extremMin: 88,
        },
        stride_length: {
          base: [119, 145],
          min: [106, 119],
          max: [145, 158],
          extremMax: 171,
          extremMin: 93,
        },
        speed: {
          base: [4.21, 5.33],
          min: [3.38, 4.21],
          max: [5.33, 5.98],
          extremMax: 6.62,
          extremMin: 2.74,
        },
      },
      {
        age: [50, 64],
        cadence: {
          base: [107, 127],
          min: [97, 107],
          max: [127, 137],
          extremMax: 147,
          extremMin: 87,
        },
        stride_length: {
          base: [117, 143],
          min: [104, 117],
          max: [143, 156],
          extremMax: 169,
          extremMin: 91,
        },
        speed: {
          base: [3.92, 5.22],
          min: [3.28, 3.92],
          max: [5.22, 5.87],
          extremMax: 6.48,
          extremMin: 2.63,
        },
      },
      {
        age: [65, 100],
        cadence: {
          base: [106, 126],
          min: [96, 106],
          max: [126, 136],
          extremMax: 146,
          extremMin: 86,
        },
        stride_length: {
          base: [107, 133],
          min: [94, 107],
          max: [133, 146],
          extremMax: 159,
          extremMin: 81,
        },
        speed: {
          base: [3.53, 4.82],
          min: [2.88, 3.53],
          max: [4.82, 5.47],
          extremMax: 6.12,
          extremMin: 2.23,
        },
      },
    ],
    men: [
      {
        age: [0, 14],
        cadence: {
          base: [112.25, 136.75],
          min: [100, 112.25],
          max: [136.75, 149],
          extremMax: 161.25,
          extremMin: 87.75,
        },
        stride_length: {
          base: [120.5, 149.5],
          min: [106, 120.5],
          max: [149.5, 164],
          extremMax: 178.5,
          extremMin: 91.5,
        },
        speed: {
          base: [4.07, 5.36],
          min: [3.42, 4.07],
          max: [5.36, 6.01],
          extremMax: 6.66,
          extremMin: 2.77,
        },
      },
      {
        age: [15, 17],
        cadence: {
          base: [107.5, 130.5],
          min: [96, 107.5],
          max: [130.5, 142],
          extremMax: 153.5,
          extremMin: 84.5,
        },
        stride_length: {
          base: [130, 160],
          min: [115, 130],
          max: [160, 175],
          extremMax: 190,
          extremMin: 100,
        },
        speed: {
          base: [4.32, 5.65],
          min: [3.71, 4.32],
          max: [5.65, 6.3],
          extremMax: 6.95,
          extremMin: 3.06,
        },
      },
      {
        age: [18, 49],
        cadence: {
          base: [102, 124],
          min: [91, 102],
          max: [124, 135],
          extremMax: 146,
          extremMin: 80,
        },
        stride_length: {
          base: [140, 170],
          min: [125, 140],
          max: [170, 185],
          extremMax: 200,
          extremMin: 110,
        },
        speed: {
          base: [4.61, 5.9],
          min: [3.96, 4.61],
          max: [5.9, 6.55],
          extremMax: 7.2,
          extremMin: 3.31,
        },
      },
      {
        age: [50, 64],
        cadence: {
          base: [93, 115],
          min: [82, 93],
          max: [115, 126],
          extremMax: 137,
          extremMin: 71,
        },
        stride_length: {
          base: [137, 167],
          min: [122, 137],
          max: [167, 182],
          extremMax: 197,
          extremMin: 107,
        },
        speed: {
          base: [4.1, 5.4],
          min: [3.46, 4.1],
          max: [5.4, 6.05],
          extremMax: 6.7,
          extremMin: 2.81,
        },
      },
      {
        age: [65, 100],
        cadence: {
          base: [92, 114],
          min: [81, 92],
          max: [114, 125],
          extremMax: 136,
          extremMin: 70,
        },
        stride_length: {
          base: [126, 156],
          min: [111, 126],
          max: [156, 171],
          extremMax: 186,
          extremMin: 96,
        },
        speed: {
          base: [3.6, 5.04],
          min: [2.92, 3.6],
          max: [5.04, 5.8],
          extremMax: 6.52,
          extremMin: 2.2,
        },
      },
    ],
  };
  private static VALUES_PRO_SUP: any = {
    women: [
      {
        age: [0, 30],
        tali: {
          abs: {
            base: [71.8, 146.6],
            min: [34.3, 71.8],
            max: [146.6, 184],
            extremMax: 221.5,
            extremMin: -3.2,
          },
          relat: {
            base: [11.5, 23.5],
            min: [5.5, 11.5],
            max: [23.5, 29.5],
            extremMax: 35.5,
            extremMin: -0.5,
          },
        },
        planti: {
          abs: {
            base: [190.3, 332.6],
            min: [119.2, 190.3],
            max: [332.6, 403.7],
            extremMax: 474.8,
            extremMin: 48.1,
          },
          relat: {
            base: [30.5, 53.3],
            min: [19.1, 30.5],
            max: [53.3, 64.7],
            extremMax: 76.1,
            extremMin: 7.7,
          },
        },
        digit: {
          abs: {
            base: [219.6, 287.04],
            min: [185.9, 219.6],
            max: [287, 320.7],
            extremMax: 354.4,
            extremMin: 152.2,
          },
          relat: {
            base: [35.2, 46],
            min: [29.8, 35.2],
            max: [46, 51.4],
            extremMax: 56.8,
            extremMin: 24.4,
          },
        },
        stance: {
          abs: {
            base: [571, 677],
            min: [518, 571],
            max: [677, 730],
            extremMax: 783,
            extremMin: 465,
          },
          relat: {
            base: [58.9, 61.9],
            min: [57.4, 58.9],
            max: [61.9, 63.4],
            extremMax: 64.9,
            extremMin: 55.9,
          },
        },
        swing: {
          abs: {
            base: [385, 431],
            min: [362, 385],
            max: [431, 454],
            extremMax: 477,
            extremMin: 339,
          },
          relat: {
            base: [38.1, 41.1],
            min: [36.6, 38.1],
            max: [41.1, 42.6],
            extremMax: 44.1,
            extremMin: 35.1,
          },
        },
        stride: {
          abs: {
            base: [962, 1102],
            min: [892, 962],
            max: [1102, 1172],
            extremMax: 1242,
            extremMin: 822,
          },
        },
      },
      {
        age: [31, 40],
        tali: {
          abs: {
            base: [74.3, 121.3],
            min: [50.7, 74.3],
            max: [121.3, 144.8],
            extremMax: 168.4,
            extremMin: 27.1,
          },
          relat: {
            base: [12, 19.6],
            min: [8.2, 12],
            max: [19.6, 23.4],
            extremMax: 27.2,
            extremMin: 4.4,
          },
        },
        planti: {
          abs: {
            base: [219.7, 339.8],
            min: [159.7, 219.7],
            max: [339.8, 399.9],
            extremMax: 459.9,
            extremMin: 99.7,
          },
          relat: {
            base: [35.5, 54.9],
            min: [25.8, 35.5],
            max: [54.9, 64.6],
            extremMax: 74.3,
            extremMin: 16.1,
          },
        },
        digit: {
          abs: {
            base: [204.9, 277.9],
            min: [168.4, 204.9],
            max: [277.9, 314.4],
            extremMax: 350.9,
            extremMin: 131.9,
          },
          relat: {
            base: [33.1, 44.9],
            min: [27.2, 33.1],
            max: [44.9, 50.8],
            extremMax: 56.7,
            extremMin: 21.3,
          },
        },
        stance: {
          abs: {
            base: [560, 678],
            min: [501, 560],
            max: [678, 737],
            extremMax: 796,
            extremMin: 442,
          },
          relat: {
            base: [59.5, 62.5],
            min: [58, 59.5],
            max: [62.5, 64],
            extremMax: 65.5,
            extremMin: 56.5,
          },
        },
        swing: {
          abs: {
            base: [369, 421],
            min: [343, 369],
            max: [421, 447],
            extremMax: 473,
            extremMin: 317,
          },
          relat: {
            base: [37.4, 40.6],
            min: [35.8, 37.4],
            max: [40.6, 42.2],
            extremMax: 43.8,
            extremMin: 34.2,
          },
        },
        stride: {
          abs: {
            base: [934, 1094],
            min: [854, 934],
            max: [1094, 1174],
            extremMax: 1254,
            extremMin: 774,
          },
        },
      },
      {
        age: [41, 50],
        tali: {
          abs: {
            base: [70.9, 162],
            min: [25.3, 70.9],
            max: [162, 207.6],
            extremMax: 253.2,
            extremMin: -20.3,
          },
          relat: {
            base: [11.2, 25.6],
            min: [4, 11.2],
            max: [25.6, 32.8],
            extremMax: 40,
            extremMin: -3.2,
          },
        },
        planti: {
          abs: {
            base: [179.8, 346.9],
            min: [96.2, 179.8],
            max: [346.9, 430.4],
            extremMax: 514,
            extremMin: 12.6,
          },
          relat: {
            base: [28.4, 54.8],
            min: [15.2, 28.4],
            max: [54.8, 68],
            extremMax: 81.2,
            extremMin: 2,
          },
        },
        digit: {
          abs: {
            base: [214.6, 291.8],
            min: [175.9, 214.6],
            max: [291.8, 330.4],
            extremMax: 369.1,
            extremMin: 137.2,
          },
          relat: {
            base: [33.9, 46.1],
            min: [27.8, 33.9],
            max: [46.1, 52.2],
            extremMax: 58.3,
            extremMin: 21.7,
          },
        },
        stance: {
          abs: {
            base: [575, 691],
            min: [517, 575],
            max: [691, 749],
            extremMax: 807,
            extremMin: 459,
          },
          relat: {
            base: [59.8, 62.2],
            min: [58.6, 59.8],
            max: [62.2, 63.4],
            extremMax: 64.6,
            extremMin: 57.4,
          },
        },
        swing: {
          abs: {
            base: [373, 435],
            min: [342, 373],
            max: [435, 466],
            extremMax: 497,
            extremMin: 311,
          },
          relat: {
            base: [37.8, 40.2],
            min: [36.6, 37.8],
            max: [40.2, 41.4],
            extremMax: 42.6,
            extremMin: 35.4,
          },
        },
        stride: {
          abs: {
            base: [950, 1122],
            min: [864, 950],
            max: [1122, 1208],
            extremMax: 1294,
            extremMin: 778,
          },
        },
      },
      {
        age: [51, 100],
        tali: {
          abs: {
            base: [66.9, 195],
            min: [2.9, 66.9],
            max: [195, 259],
            extremMax: 323,
            extremMin: -61.1,
          },
          relat: {
            base: [9.5, 27.7],
            min: [0.4, 9.5],
            max: [27.7, 36.8],
            extremMax: 45.9,
            extremMin: -8.7,
          },
        },
        planti: {
          abs: {
            base: [204.2, 380.2],
            min: [116.2, 204.2],
            max: [380.2, 468.2],
            extremMax: 556.2,
            extremMin: 28.2,
          },
          relat: {
            base: [28, 54],
            min: [16.5, 28],
            max: [54, 66.5],
            extremMax: 78,
            extremMin: 5,
          },
        },
        digit: {
          abs: {
            base: [256.2, 304.1],
            min: [232.3, 256.2],
            max: [304.1, 328],
            extremMax: 351.9,
            extremMin: 208.4,
          },
          relat: {
            base: [36.4, 43.2],
            min: [33, 36.4],
            max: [43.2, 46.6],
            extremMax: 50,
            extremMin: 29.6,
          },
        },
        stance: {
          abs: {
            base: [599, 809],
            min: [494, 599],
            max: [809, 914],
            extremMax: 1019,
            extremMin: 389,
          },
          relat: {
            base: [61.3, 64.1],
            min: [59.9, 61.3],
            max: [64.1, 65.5],
            extremMax: 66.9,
            extremMin: 58.5,
          },
        },
        swing: {
          abs: {
            base: [379, 451],
            min: [343, 379],
            max: [451, 487],
            extremMax: 523,
            extremMin: 307,
          },
          relat: {
            base: [35.8, 38.6],
            min: [34.4, 35.8],
            max: [38.6, 40],
            extremMax: 41.4,
            extremMin: 33,
          },
        },
        stride: {
          abs: {
            base: [979, 1261],
            min: [838, 979],
            max: [1261, 1402],
            extremMax: 1543,
            extremMin: 697,
          },
        },
      },
    ],
    men: [
      {
        age: [0, 30],
        tali: {
          abs: {
            base: [70.9, 169.9],
            min: [21.4, 70.9],
            max: [169.9, 219.4],
            extremMax: 268.9,
            extremMin: -28.1,
          },
          relat: {
            base: [10.6, 25.4],
            min: [3.2, 10.6],
            max: [25.4, 32.8],
            extremMax: 40.2,
            extremMin: -4.2,
          },
        },
        planti: {
          abs: {
            base: [205.7, 408.7],
            min: [103.7, 205.7],
            max: [408.7, 510.4],
            extremMax: 612.4,
            extremMin: 1.7,
          },
          relat: {
            base: [30.7, 61.1],
            min: [15.5, 30.7],
            max: [61.1, 76.3],
            extremMax: 91.5,
            extremMin: 0.3,
          },
        },
        digit: {
          abs: {
            base: [189.3, 293.7],
            min: [137.1, 189.3],
            max: [293.7, 345.9],
            extremMax: 398.1,
            extremMin: 84.9,
          },
          relat: {
            base: [28.3, 43.9],
            min: [20.5, 28.3],
            max: [43.9, 51.7],
            extremMax: 59.5,
            extremMin: 12.7,
          },
        },
        stance: {
          abs: {
            base: [623, 715],
            min: [577, 623],
            max: [715, 761],
            extremMax: 807,
            extremMin: 531,
          },
          relat: {
            base: [59.8, 62],
            min: [58.7, 59.8],
            max: [62, 63.1],
            extremMax: 64.2,
            extremMin: 57.6,
          },
        },
        swing: {
          abs: {
            base: [403, 455],
            min: [377, 403],
            max: [455, 481],
            extremMax: 507,
            extremMin: 351,
          },
          relat: {
            base: [38, 40.2],
            min: [36.9, 38],
            max: [40.2, 41.3],
            extremMax: 42.4,
            extremMin: 35.8,
          },
        },
        stride: {
          abs: {
            base: [1030, 1166],
            min: [962, 1030],
            max: [1166, 1234],
            extremMax: 1302,
            extremMin: 894,
          },
        },
      },
      {
        age: [31, 40],
        tali: {
          abs: {
            base: [80.8, 132.9],
            min: [54.8, 80.8],
            max: [132.9, 158.9],
            extremMax: 184.9,
            extremMin: 28.8,
          },
          relat: {
            base: [11.8, 19.4],
            min: [8, 11.8],
            max: [19.4, 23.2],
            extremMax: 27,
            extremMin: 4.2,
          },
        },
        planti: {
          abs: {
            base: [263.7, 387],
            min: [202, 263.7],
            max: [387, 448.7],
            extremMax: 510.4,
            extremMin: 140.3,
          },
          relat: {
            base: [38.5, 56.5],
            min: [29.5, 38.5],
            max: [56.5, 65.5],
            extremMax: 74.5,
            extremMin: 20.5,
          },
        },
        digit: {
          abs: {
            base: [216.4, 289.07],
            min: [180.1, 216.4],
            max: [289, 325.4],
            extremMax: 361.7,
            extremMin: 143.8,
          },
          relat: {
            base: [31.6, 42.2],
            min: [26.3, 31.6],
            max: [42.2, 47.5],
            extremMax: 52.8,
            extremMin: 21,
          },
        },
        stance: {
          abs: {
            base: [628, 742],
            min: [571, 628],
            max: [742, 799],
            extremMax: 856,
            extremMin: 514,
          },
          relat: {
            base: [60.2, 62.4],
            min: [59.1, 60.2],
            max: [62.4, 63.5],
            extremMax: 64.6,
            extremMin: 58,
          },
        },
        swing: {
          abs: {
            base: [413, 449],
            min: [395, 413],
            max: [449, 467],
            extremMax: 485,
            extremMin: 377,
          },
          relat: {
            base: [37.6, 39.8],
            min: [36.5, 37.6],
            max: [39.8, 40.9],
            extremMax: 42,
            extremMin: 35.4,
          },
        },
        stride: {
          abs: {
            base: [1041, 1191],
            min: [966, 1041],
            max: [1191, 1266],
            extremMax: 1341,
            extremMin: 891,
          },
        },
      },
      {
        age: [41, 50],
        tali: {
          abs: {
            base: [85.6, 122.4],
            min: [67.2, 85.6],
            max: [122.4, 140.7],
            extremMax: 159.1,
            extremMin: 48.8,
          },
          relat: {
            base: [13.5, 19.3],
            min: [10.6, 13.5],
            max: [19.3, 22.2],
            extremMax: 25.1,
            extremMin: 7.7,
          },
        },
        planti: {
          abs: {
            base: [248.5, 407],
            min: [169.3, 248.5],
            max: [407, 486.3],
            extremMax: 565.5,
            extremMin: 90.1,
          },
          relat: {
            base: [39.2, 64.2],
            min: [26.7, 39.2],
            max: [64.2, 76.7],
            extremMax: 89.2,
            extremMin: 14.2,
          },
        },
        digit: {
          abs: {
            base: [140.748, 263.7],
            min: [79.25, 140.7],
            max: [263.7, 325.2],
            extremMax: 386.65,
            extremMin: 17.8,
          },
          relat: {
            base: [22.2, 41.6],
            min: [12.5, 22.2],
            max: [41.6, 51.3],
            extremMax: 61,
            extremMin: 2.8,
          },
        },
        stance: {
          abs: {
            base: [618, 650],
            min: [602, 618],
            max: [650, 666],
            extremMax: 682,
            extremMin: 586,
          },
          relat: {
            base: [58.3, 62.1],
            min: [56.4, 58.3],
            max: [62.1, 64],
            extremMax: 65.9,
            extremMin: 54.5,
          },
        },
        swing: {
          abs: {
            base: [391, 447],
            min: [363, 391],
            max: [447, 475],
            extremMax: 503,
            extremMin: 335,
          },
          relat: {
            base: [37.9, 41.7],
            min: [36, 37.9],
            max: [41.7, 43.6],
            extremMax: 45.5,
            extremMin: 34.1,
          },
        },
        stride: {
          abs: {
            base: [1029, 1079],
            min: [1004, 1029],
            max: [1079, 1104],
            extremMax: 1129,
            extremMin: 979,
          },
        },
      },
      {
        age: [51, 100],
        tali: {
          abs: {
            base: [94.7, 110.7],
            min: [86.7, 94.7],
            max: [110.7, 118.7],
            extremMax: 126.7,
            extremMin: 78.7,
          },
          relat: {
            base: [14.2, 16.6],
            min: [13, 14.2],
            max: [16.6, 17.8],
            extremMax: 19,
            extremMin: 11.8,
          },
        },
        planti: {
          abs: {
            base: [274.1, 334.2],
            min: [244.1, 274.1],
            max: [334.2, 364.1],
            extremMax: 394.1,
            extremMin: 214.1,
          },
          relat: {
            base: [41.1, 50.1],
            min: [36.6, 41.1],
            max: [50.1, 54.6],
            extremMax: 59.1,
            extremMin: 32.1,
          },
        },
        digit: {
          abs: {
            base: [238.1, 282.1],
            min: [216.1, 238.1],
            max: [282.1, 304.1],
            extremMax: 326.1,
            extremMin: 194.1,
          },
          relat: {
            base: [35.7, 42.3],
            min: [32.4, 35.7],
            max: [42.3, 45.6],
            extremMax: 48.9,
            extremMin: 29.1,
          },
        },
        stance: {
          abs: {
            base: [586, 748],
            min: [505, 586],
            max: [748, 829],
            extremMax: 910,
            extremMin: 424,
          },
          relat: {
            base: [59, 61.8],
            min: [57.6, 59],
            max: [61.8, 63.2],
            extremMax: 64.6,
            extremMin: 56.2,
          },
        },
        swing: {
          abs: {
            base: [403, 467],
            min: [371, 403],
            max: [467, 499],
            extremMax: 531,
            extremMin: 339,
          },
          relat: {
            base: [38.1, 40.9],
            min: [36.7, 38.1],
            max: [40.9, 42.3],
            extremMax: 43.7,
            extremMin: 35.3,
          },
        },
        stride: {
          abs: {
            base: [991, 1213],
            min: [880, 991],
            max: [1213, 1324],
            extremMax: 1435,
            extremMin: 769,
          },
        },
      },
    ],
  };

  /**
   *  Get data
   * @param gender
   * @param age
   * @param type
   * @param value
   */
  public static getGeneral(gender: number, age: number, type: string, value: any): EColorState {
    age = this.formatAge(age);
    const ref = RefInt.VALUES_GENERAL[this.getGender(gender)]!.find((x: any) => x.age[0] <= age && x.age[1] >= age)![
      type
    ];

    switch (true) {
      case value >= ref.base[0] && value <= ref.base[1]:
        return EColorState.goodRange;
      case value >= ref.max[0] && value <= ref.max[1]:
      case value >= ref.min[0] && value <= ref.min[1]:
        return EColorState.warningRange;
      default:
        return EColorState.badRange;
    }
  }

  /**
   * Get pro sup
   * @param gender
   * @param age
   * @param type
   * @param unit
   * @param value
   */
  public static getProSup(gender: number, age: number, type: string, unit: string, value: any): EColorState {
    age = this.formatAge(age);
    const ref = RefInt.VALUES_PRO_SUP[this.getGender(gender)].find((x: any) => x.age[0] <= age && x.age[1] >= age)[
      type
    ][unit];
    switch (true) {
      case value >= ref.base[0] && value <= ref.base[1]:
        return EColorState.goodRange;
      case value >= ref.max[0] && value <= ref.max[1]:
      case value >= ref.min[0] && value <= ref.min[1]:
        return EColorState.warningRange;
      default:
        return EColorState.badRange;
    }
  }

  /**
   * Get range
   * @param gender
   * @param age
   * @param vType
   * @param vName
   * @param unitType
   */
  public static getRange(gender: number, age: number, vType: string, vName: string, unitType?: any) {
    age = this.formatAge(age);
    // TODO access to the class data with dynamic properties
    let values: any = null;
    if (vType === 'GENERAL') values = RefInt.VALUES_GENERAL;
    if (vType === 'PRO_SUP') values = RefInt.VALUES_PRO_SUP;
    const valuesByGender = values[this.getGender(gender)].find((x: any) => x.age[0] <= age && x.age[1] >= age);
    let get: any = null;
    if (vType === 'PRO_SUP') {
      get = valuesByGender[vName];
      get = get[unitType];
    } else {
      get = valuesByGender[vName];
    }
    return {
      base: { min: get.base[0], max: get.base[1] },
      minRange: { min: get.min[0], max: get.min[1] },
      maxRange: { min: get.max[0], max: get.max[1] },
      extremMin: get.extremMin,
      extremMax: get.extremMax,
    };
  }

  private static getGender(code: number) {
    if (code === 1) return 'men';
    return 'women';
  }
  private static formatAge(age: number) {
    if (age < 0) return 0;
    if (age > 100) return 100;
    return age;
  }
}
